import React from 'react';
import FormInput from 'components/Input/FormInput';

interface IProps {
	changePrice: (value: Nullable<number>) => void;
	isDisabled: boolean;
}

export const PriceInput: React.FC<IProps> = React.memo(({ changePrice, isDisabled }) => (
	<FormInput
		testId="PriceInput"
		name="price"
		label="signedPriceLabel"
		min={0}
		precision={0}
		disabled={isDisabled}
		onChangeNumber={changePrice}
		type="number"
	/>
));
